import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source" ]

  connect() {
    console.log("Clipboard controller connected to:", this.element)
  }

  copy(event) {
  event.preventDefault()
  
  // 1. Capture the reference IMMEDIATELY
  const button = event.currentTarget 
  
  // 2. Get the text to copy
  const textToCopy = this.sourceTarget.innerText || this.sourceTarget.textContent
  
  // 3. Start the async call
  navigator.clipboard.writeText(textToCopy).then(() => {
    // 4. Use the CAPTURED variable, not the event object
    this.animateButton(button)
  }).catch(err => {
    console.error("Clipboard error:", err)
  })
}
  // Copies title + description as two lines (title on line 1, description below)
  // so the Spoonflower fill bookmarklet can populate both fields from one paste.
  copyBoth(event) {
    event.preventDefault()

    const button = event.currentTarget
    const title = (button.dataset.title || "").trim()
    const description = (button.dataset.description || "").trim()
    const textToCopy = `${title}\n${description}`

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.animateButton(button)
    }).catch(err => {
      console.error("Clipboard error:", err)
    })
  }

  animateButton(button) {
  if (!button) return // Safety check
  
  const originalHTML = button.innerHTML
  button.innerHTML = '✅' 
  setTimeout(() => { 
    button.innerHTML = originalHTML 
  }, 2000)
}
}